import { FilterOptionLite } from '../../utils/reportFilters';

export type FilterDimensionOption = FilterOptionLite;

export function option_key(item: FilterDimensionOption): string {
  return `${typeof item.id}:${String(item.id)}`;
}

export function is_option_in_list(
  list: FilterDimensionOption[],
  item: FilterDimensionOption
): boolean {
  return list.some((row) => String(row.id) === String(item.id));
}

export function append_dimension_option(
  selected: FilterDimensionOption[],
  item: FilterDimensionOption,
  exclude_ids: Set<string> = new Set()
): FilterDimensionOption[] {
  if (is_option_in_list(selected, item)) return selected;
  if (exclude_ids.has(String(item.id))) return selected;
  return [...selected, item];
}

export function remove_dimension_option(
  selected: FilterDimensionOption[],
  item: FilterDimensionOption
): FilterDimensionOption[] {
  return selected.filter((row) => String(row.id) !== String(item.id));
}

export function addable_dimension_rows(
  results: FilterDimensionOption[],
  selected: FilterDimensionOption[],
  exclude_ids: Set<string> = new Set()
): FilterDimensionOption[] {
  const selected_keys = new Set(selected.map((s) => String(s.id)));
  return results.filter((row) => {
    const k = String(row.id);
    if (selected_keys.has(k)) return false;
    if (exclude_ids.has(k)) return false;
    return true;
  });
}
